/** Named container so toolbar labels collapse with the panel width, not the viewport. */
export const TOOLBAR_CONTAINER_CLASSNAME = '@container/chron-toolbar';

export const TOOLBAR_BUTTON_CLASSNAME =
  'inline-flex h-8 shrink-0 items-center gap-1.5 rounded-md border border-gray-200 bg-white px-2.5 text-[13px] text-gray-600 '
  + 'transition-colors hover:border-gray-300 hover:text-gray-900 '
  + 'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-gray-300/60';

export const TOOLBAR_BUTTON_ACTIVE_CLASSNAME = 'border-gray-300 text-gray-900';

/** Secondary labels (Export, view names) that give way first when the panel is narrow. */
export const TOOLBAR_LABEL_CLASSNAME = '@max-[720px]/chron-toolbar:hidden';
